"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mxSuperProps = exports.mxUserProps = exports.mxReset = exports.mxInit = exports.getEventTracker = exports.mxIsInitialized = void 0;

var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @ts-ignore
let mixpanelDistinctId = null;

const mxIsInitialized = () => {
  return !!mixpanelDistinctId;
};

exports.mxIsInitialized = mxIsInitialized;

const getEventTracker = eventPrefix => {
  return (title, props) => {
    if (!title || !props) {
      console.warn('Trying to record mixpanel event with incorrect data, ignored.', title, props);
      return;
    }

    const eventTitle = eventPrefix ? `${eventPrefix}: ${title}` : title;

    if (!mxIsInitialized()) {
      console.warn('Mixpanel not loaded yet, ignoring event', eventTitle);
      return;
    }

    _mixpanelBrowser.default.track(eventTitle, props);
  };
};

exports.getEventTracker = getEventTracker;

const mxInit = (mixpanelProjectId, onLoad) => {
  _mixpanelBrowser.default.init(mixpanelProjectId, {
    loaded() {
      mixpanelDistinctId = _mixpanelBrowser.default.get_distinct_id();

      if (onLoad) {
        onLoad();
      }
    }

  });
};

exports.mxInit = mxInit;

const mxReset = () => {
  if (!mxIsInitialized()) {
    return;
  }

  _mixpanelBrowser.default.reset();
};

exports.mxReset = mxReset;

const mxUserProps = (userId, props) => {
  if (!mxIsInitialized()) {
    return;
  }

  _mixpanelBrowser.default.people.set(props);

  _mixpanelBrowser.default.identify(userId);
};

exports.mxUserProps = mxUserProps;

const mxSuperProps = props => {
  if (!mxIsInitialized()) {
    return;
  }

  _mixpanelBrowser.default.register(props);
};

exports.mxSuperProps = mxSuperProps;